import React, { createContext, useContext, useState } from 'react';
import { api } from 'app';

const FilesUIContext = createContext();

export function useFilesUIContext() {
  return useContext(FilesUIContext);
}

export function FilesUIProvider({ children }) {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const [statuses, setStatuses] = useState({});

  const fetchData = async query => {
    const q = query ? query.slice(1) : '';
    setIsLoading(true);
    api
      .get(`/admin/files?include=event&${q}`)
      .then(response => {
        setData(response);
        // Extract statuses from meta if available
        if (response.body && response.body.meta && response.body.meta.statuses) {
          setStatuses(response.body.meta.statuses);
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const value = {
    fetchData,
    data,
    setData,
    isLoading,
    setIsLoading,
    statuses
  };

  return <FilesUIContext.Provider value={value}>{children}</FilesUIContext.Provider>;
}
